<form *ngIf="virtualAgentIntegration" [formGroup]="form" (ngSubmit)="onSubmitForm($event)">
  <div class="form-group pt-2" formGroupName="endpoint">
    <label class="indicates-required-field" for="endpoint">
      {{ 'Settings::RTGVirtualAgent:Endpoint' | abpLocalization }}
    </label>
    <input type="text" class="form-control form-control-sm" id="endpoint" formControlName="value" />
    <small class="form-text text-muted">
      {{ 'Settings::RTGVirtualAgent:EndpointDescription' | abpLocalization }}
    </small>
  </div>
  <div class="form-group pt-2" formGroupName="identityBaseEndpoint">
    <label class="indicates-required-field" for="identityBaseEndpoint">
      {{ 'Settings::RTGVirtualAgent:IdentityBaseEndpoint' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="identityBaseEndpoint"
      formControlName="value" />
    <small class="form-text text-muted">
      {{ 'Settings::RTGVirtualAgent:IdentityBaseEndpointDescription' | abpLocalization }}
    </small>
  </div>
  <div class="form-group pt-2" formGroupName="clientId">
    <label [ngClass]="!isSavedBefore ? 'indicates-required-field' : ''" for="clientId">
      {{ 'Settings::RTGVirtualAgent:ClientId' | abpLocalization }}
    </label>
    <input
      type="password"
      [placeholder]="'Settings::MaskedAreaPlaceholder' | abpLocalization"
      class="form-control form-control-sm"
      id="clientId"
      formControlName="value" />
    <small class="form-text text-muted">
      {{ 'Settings::RTGVirtualAgent:ClientIdDescription' | abpLocalization }}
    </small>
  </div>
  <div class="form-group pt-2" formGroupName="clientSecret">
    <label [ngClass]="!isSavedBefore ? 'indicates-required-field' : ''" for="clientSecret">
      {{ 'Settings::RTGVirtualAgent:ClientSecret' | abpLocalization }}
    </label>
    <input
      type="password"
      class="form-control form-control-sm"
      id="clientSecret"
      [placeholder]="'Settings::MaskedAreaPlaceholder' | abpLocalization"
      formControlName="value" />
    <small class="form-text text-muted">
      {{ 'Settings::RTGVirtualAgent:ClientSecretDescription' | abpLocalization }}
    </small>
  </div>
  <div class="form-group pt-2" formGroupName="webChatId">
    <label for="webChatId">
      {{ 'Settings::RTGVirtualAgent:WebChatId' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="webChatId"
      formControlName="value" />
    <small class="form-text text-muted">
      {{ 'Settings::RTGVirtualAgent:WebChatIdDescription' | abpLocalization }}
    </small>
  </div>
  <div class="form-group pt-2" formGroupName="postConversationProject">
    <label for="postConversationProject">
      {{ 'Settings::RTGVirtualAgent:PostConversationProject' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="postConversationProject"
      formControlName="value" />
    <small class="form-text text-muted">
      {{ 'Settings::RTGVirtualAgent:PostConversationProjectDescription' | abpLocalization }}
    </small>
  </div>
  <div class="form-group pt-2" formGroupName="aiChatTenant">
    <label for="aiChatTenant">
      {{ 'Settings::RTGVirtualAgent:AIChatTenant' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="aiChatTenant"
      formControlName="value" />
    <small class="form-text text-muted">
      {{ 'Settings::RTGVirtualAgent:AIChatTenantDescription' | abpLocalization }}
    </small>
  </div>
  <div class="form-group pt-2" formGroupName="aiChatProject">
    <label for="aiChatProject">
      {{ 'Settings::RTGVirtualAgent:AIChatProject' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="aiChatProject"
      formControlName="value" />
    <small class="form-text text-muted">
      {{ 'Settings::RTGVirtualAgent:AIChatProjectDescription' | abpLocalization }}
    </small>
  </div>
  <button type="button" type="submit" class="btn btn-primary mt-3" [disabled]="!form.valid">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
